import Inputmask from "inputmask";
Inputmask.extendAliases({
    appCurrency: {
        alias: "numeric",
        groupSeparator: ".",
        radixPoint: ",",
        numericInput: true,
        rightAlign: false,
        autoUnmask: true,
        unmaskAsNumber: true,
        placeholder: "0",
        digits: 2,
        digitsOptional: true,
        onBeforeMask: function (value, opts) {
            if (null === value) {
                // fix charAt on null errors
                value = "0";
            }
            return value;
        },
    },
});
window.Inputmask = Inputmask;
